import * as Api from './api';
import {CdcService} from './cdc';
import {isLoggedin} from './utils';

const NS = 'findInStore';

export function saveSelectedStore(store, successCB) {
	const cdcService = new CdcService();
	let saveToLocalStorage = () => {
		if (!window.localStorage) return;

		store = convertStore(store);

		window.localStorage.setItem(`bris.${NS}.value`, JSON.stringify(store));
	};

	let saveToDb = () => {
		let endpoint = $('.endpoints-definition').data('set-store-endpoint');
		if (!endpoint) {
			console.error(`"data-select-store-endpoint" couldn't find. Please set the endpoint on "endpoints-definition". Returned early.`);
		}

		let param = {
			storeId: store.storeId,
		};

		window.gigya && cdcService.setStoreById(store.storeId);

		Api.callApi(endpoint, param).then((data) => {
			saveToLocalStorage();
			if (data.result == 'SUCCESS') {
				if (successCB) {
					successCB();
				}
			} else {
				console.error(data.message || 'Find in store. Error set store.');
			}
		}).catch(saveToLocalStorage);
	};

	saveToDb();
}

export function checkLocalStorage() {
	const data = {
		storeInfo: {
			storeId: '',
			storeName: '',
			contentLinkID: '',
			regionId: '',
			branchSearch: '',
		},
	};

	if (isLoggedin() && window.selectedStore && window.localStorage) {
		const storeInfo = {
			storeName: storeNameShorter(window.selectedStore.name),
			storeId: window.selectedStore.fulfilmentNumber,
			contentLinkID: window.selectedStore.contentLinkID,
		};
		window.localStorage.setItem(`bris.${NS}.value`, JSON.stringify(storeInfo));
		delete window.selectedStore;
	}
	if (window.localStorage) {
		let storeValue = window.localStorage.getItem(`bris.${NS}.value`);
		if (storeValue) {
			data.storeInfo = JSON.parse(storeValue);
			data.storeInfo.store = convertStore(data.storeInfo.store);
		}
	}

	return data;
}

export function convertStore(store) {
	if (store && store.storeName) {
		store.storeName = storeNameShorter(store.storeName);
	}
	return store;
}

export function storeNameShorter(name) {
	return name
		.replace('Briscoes ', '')
		.replace('Rebel Sport ', '')
		.replace('Living & Giving ', '')
		.replace('Living &amp; Giving ', '');
}



// WEBPACK FOOTER //
// ./findInStore.js